import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Api } from '@definitions/apis';
import { Observable, of } from 'rxjs';
import { ApisService } from '../services/apis.service';

export const apiResolverFn = (
	route: ActivatedRouteSnapshot
): Observable<Api> => {
	const apisSvc = inject(ApisService);
	const apiId = route.paramMap.get('apiId');

	return apiId ? apisSvc.find(apiId) : of(null);
};
